import { SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Col,
  Input,
  Row,
  Space,
  Table,
  Tooltip
} from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

function ArchiveBulkOrderList() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const dataSource = [
    {
      key: '1',
      srNo: '1',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '2',
      srNo: '2',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '3',
      srNo: '3',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '4',
      srNo: '4',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '5',
      srNo: '5',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '6',
      srNo: '6',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
    {
      key: '7',
      srNo: '7',
      partyName: 'Psp Projects Limited',
      orderDate: '18 Oct 2024',
      incidentNo: '123456',
      remarks: 'Remark here',
    },
  ];

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'srNo',
      sorter: (a, b) => a.srNo - b.srNo,
    },
    {
      title: 'Party Name',
      dataIndex: 'partyName',
      sorter: (a, b) => a.partyName.localeCompare(b.partyName),
    },
    {
      title: 'Order Date',
      dataIndex: 'orderDate',
      sorter: (a, b) => new Date(a.orderDate) - new Date(b.orderDate),
    },
    {
      title: 'Incident No',
      dataIndex: 'incidentNo',
      sorter: (a, b) => a.incidentNo - b.incidentNo,
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
    },
    {
      title: 'Archive At',
      dataIndex: 'archive_at',
      key: 'archive_at',
      sorter: true,
    },
    {
      title: 'Archive By',
      dataIndex: 'archive_by',
      key: 'archive_by',
      sorter: true,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link>
            <Tooltip title='Edit'>
              <EditIcon />
            </Tooltip>
          </Link>
          <Link>
            <Tooltip title='Archive'>
              <Archive />
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const onSearchChange = e => {
    setSearchText(e.target.value);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedKeys => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const showDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  const onFinish = values => {
   
    closeDrawer();
  };
  return (
    <>
      <Row className="pagenamerow" justify="space-between" align="middle">
        <Col>
          <h2>Archive Bulk Order</h2>
          <div className="bredcrumbwrp">
            <Link to="/bulk-order-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/bulk-order-list">Bulk Order</Link> },
                { title: 'Archive Bulk Order List' }
              ]}
            />
          </div>
        </Col>
        <Col>
          <Space size="middle">
            <Input
              placeholder="Search"
                  className='searchbox'
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={onSearchChange}
              style={{ width: '100%' }}
            />
            <Link className='iconlink'>
              <Tooltip title="Filter">
                <FilterIcon />
              </Tooltip>
            </Link>
          </Space>
        </Col>

      </Row>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        className="mt-5"
        scroll={{
          x: 880,
        }}
      />

    </>
  );
}

export default ArchiveBulkOrderList;
